import React, { useState } from 'react';
import { Mountain, LogIn, Eye, EyeOff, AlertCircle } from 'lucide-react';
const USERS = [{
  username: 'rishi',
  password: '1234',
  name: 'Rishi',
  role: 'Admin',
  seed: 'Rishi',
  birthday: '02-07'
}, {
  username: 'sanjay',
  password: '1234',
  name: 'Sanjay',
  role: 'Operations',
  seed: 'Sanjay',
  birthday: '03-15'
}, {
  username: 'priya',
  password: '1234',
  name: 'Priya',
  role: 'Billing',
  seed: 'Priya',
  birthday: '07-22'
}, {
  username: 'amit',
  password: '1234',
  name: 'Amit',
  role: 'Warehouse',
  seed: 'Amit',
  birthday: '01-10'
}, {
  username: 'neha',
  password: '1234',
  name: 'Neha',
  role: 'Accounts',
  seed: 'Neha',
  birthday: '11-05'
}, {
  username: 'rajesh',
  password: '1234',
  name: 'Rajesh',
  role: 'Supervisor',
  seed: 'Rajesh',
  birthday: '09-18'
}, {
  username: 'sunita',
  password: '1234',
  name: 'Sunita',
  role: 'Documentation',
  seed: 'Sunita',
  birthday: '04-30'
}, {
  username: 'manoj',
  password: '1234',
  name: 'Manoj',
  role: 'IT Support',
  seed: 'Manoj',
  birthday: '06-12'
}, {
  username: 'kavita',
  password: '1234',
  name: 'Kavita',
  role: 'HR',
  seed: 'Kavita',
  birthday: '12-25'
}, {
  username: 'deepak',
  password: '1234',
  name: 'Deepak',
  role: 'Logistics',
  seed: 'Deepak',
  birthday: '08-08'
}, {
  username: 'anita',
  password: '1234',
  name: 'Anita',
  role: 'Customs',
  seed: 'Anita',
  birthday: '05-20'
}, {
  username: 'vikram',
  password: '1234',
  name: 'Vikram',
  role: 'Security',
  seed: 'Vikram',
  birthday: '10-14'
}];
export interface LoggedInUser {
  name: string;
  role: string;
  seed: string;
  birthday: string;
}
interface LoginScreenProps {
  onLogin: (user: LoggedInUser) => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      return;
    }
    setIsLoading(true);
    // Simulate login delay
    setTimeout(() => {
      const user = USERS.find(u => u.username.toLowerCase() === username.toLowerCase() && u.password === password);
      if (user) {
        onLogin({
          name: user.name,
          role: user.role,
          seed: user.seed,
          birthday: user.birthday
        });
      } else {
        setError('Invalid username or password');
        setIsLoading(false);
      }
    }, 800);
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] overflow-hidden" data-id="element-564">
      {/* Animated background shapes */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-565">
        <div className="absolute -top-20 -left-20 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl" data-id="element-566" />
        <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-orange-400/10 rounded-full blur-3xl" data-id="element-567" />
        <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-blue-500/5 rounded-full blur-2xl" data-id="element-568" />
      </div>

      <div className="relative w-full max-w-md mx-4" data-id="element-569">
        {/* Login Card */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl border border-white/20 shadow-2xl p-8" data-id="element-570">
          {/* Company Header */}
          <div className="flex flex-col items-center mb-8" data-id="element-571">
            <div className="relative mb-4" data-id="element-572">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl flex items-center justify-center shadow-lg" data-id="element-573">
                <Mountain className="w-12 h-12 text-white" strokeWidth={1.5} data-id="element-574" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full border-3 border-[#16213e] flex items-center justify-center" data-id="element-575">
                <div className="w-2 h-2 bg-white rounded-full" data-id="element-576" />
              </div>
            </div>
            <h1 className="text-white text-2xl font-bold tracking-wide" data-id="element-577">
              ERPLogiPark
            </h1>
            <p className="text-white/50 text-sm mt-1" data-id="element-578">
              Terminal Management System
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-579">
            {/* Username */}
            <div className="space-y-2" data-id="element-580">
              <label className="text-white/70 text-sm font-medium" data-id="element-581">
                Username
              </label>
              <input type="text" value={username} onChange={e => {
              setUsername(e.target.value);
              setError('');
            }} placeholder="Enter your username" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-orange-500/50 focus:border-orange-500/50 transition-all" autoFocus data-id="element-582" />
            </div>

            {/* Password */}
            <div className="space-y-2" data-id="element-583">
              <label className="text-white/70 text-sm font-medium" data-id="element-584">
                Password
              </label>
              <div className="relative" data-id="element-585">
                <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setError('');
              }} placeholder="Enter your password" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-orange-500/50 focus:border-orange-500/50 transition-all pr-12" data-id="element-586" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors" data-id="element-587">
                  {showPassword ? <EyeOff size={18} data-id="element-588" /> : <Eye size={18} data-id="element-589" />}
                </button>
              </div>
            </div>

            {/* Error Message */}
            {error && <div className="flex items-center gap-2 text-red-400 text-sm bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2.5" data-id="element-590">
                <AlertCircle size={16} data-id="element-591" />
                {error}
              </div>}

            {/* Login Button */}
            <button type="submit" disabled={isLoading} className="w-full py-3.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-lg shadow-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-592">
              {isLoading ? <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-593" /> : <>
                  <LogIn size={18} data-id="element-594" />
                  Sign In
                </>}
            </button>
          </form>

          {/* Hint */}
          <div className="mt-6 pt-5 border-t border-white/10 text-center" data-id="element-595">
            <p className="text-white/30 text-xs" data-id="element-596">
              Use any employee name as username with password{' '}
              <span className="text-orange-400/60 font-mono" data-id="element-597">1234</span>
            </p>
            <p className="text-white/20 text-[10px] mt-2" data-id="element-598">
              e.g. rishi, sanjay, priya, amit, neha...
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-white/20 text-xs text-center mt-6" data-id="element-599">
          © 2025 ERPLogiPark Pvt. Ltd. All rights reserved.
        </p>
      </div>
    </div>;
}